import { render, staticRenderFns } from "./ClosingReasonsFilters.vue?vue&type=template&id=4b260f20&"
import script from "./ClosingReasonsFilters.vue?vue&type=script&lang=js&"
export * from "./ClosingReasonsFilters.vue?vue&type=script&lang=js&"
import style0 from "./ClosingReasonsFilters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports